import React from 'react';
import { HexColorInput } from 'react-colorful';
import { cx } from '@emotion/css';
import ColorizeTwoToneIcon from '@mui/icons-material/ColorizeTwoTone';
import { ix } from '../../../../utils/ix';
import useStyles from './ColorInput.styles';
export function ColorInput(props) {
    const classes = useStyles();
    return (React.createElement("div", { id: props.id, className: cx(props.className, classes.root) },
        React.createElement("div", { className: classes.inputWrapper },
            React.createElement(ColorizeTwoToneIcon, { color: "secondary" }),
            React.createElement(HexColorInput, { id: ix(props.id, 'input'), className: classes.input, color: props.value, prefixed: true, readOnly: props.readonly, onChange: props.onChange })),
        React.createElement("div", { className: classes.colorSwatch },
            React.createElement("div", { className: classes.colorCircle, style: { background: props.value } }))));
}
//# sourceMappingURL=ColorInput.js.map